import React from 'react';

/**
 * See http://survivejs.com/webpack_react/react_and_flux/
 */
const connectStore = (Component, store, key) => class ConnectToStore extends React.Component {
  constructor(props) {
    super(props);
    this.onChange = this.onChange.bind(this);
    this.state = store.getState();
  }

  componentDidMount() {
    store.listen(this.onChange);
  }

  componentWillUnmount() {
    store.unlisten(this.onChange);
  }

  onChange() {
    this.setState(store.getState());
  }

  render() {
    const state = {};
    state[key] = this.state;
    return <Component {...state} {...this.props} />;
  }
};

export default (store, key) => target => connectStore(target, store, key);
